import { createContext, useContext } from "react";

export const TourContext = createContext({
  tourRunning: false,
  activeTourKey: null,
  currentStep: 0,
  // stepRef.current always holds the live step index — use inside event handlers
  // to avoid stale-closure bugs (React state updates are async)
  stepRef: { current: 0 },
  controls: null,
  canAdvance: true,
  setCanAdvance: () => {},
  startTour: (_key, _fromStep) => {},
  // Starts an ordered sequence of tours. Each item: { key, fromStep, name }.
  // When one tour finishes, the next auto-starts; TourTooltip shows
  // "Next: {name}" on the last step of each tour except the final one.
  startPipeline: (_pipeline) => {},
  // { key, name } of the next tour in the pipeline, or null if last/solo.
  nextPipelineTour: null,
  // Call this when the user explicitly skips/closes so tour:end does NOT
  // auto-advance to the next pipeline entry.
  abortPipeline: () => {},
  stopTour: () => {},
  // True after the user clicks Skip — drives the skip confirmation modal.
  skipModalOpen: false,
  closeSkipModal: () => {},
  // True after a tour completes normally — drives the finish modal.
  finishModalOpen: false,
  // { isFullTour: bool, nextTour: { key, name } | null }
  finishModalData: null,
  closeFinishModal: () => {},
  // Called by LearningCenter on data load to set the global flat tour sequence.
  setGlobalTourSequence: (_flatTours) => {},
});

export const useTour = () => useContext(TourContext);
